<script setup lang="ts"></script>

<template>
  <div :class="$style.tableWrapper">
    <table :class="[$style.table, $style['table--grayFirstCol']]">
      <slot></slot>
    </table>
  </div>
</template>

<style lang="scss" module>
.tableWrapper {
  overflow-x: scroll;
  margin-bottom: 16px;
  &:nth-child(n + 2) {
    margin-top: 8px;
  }

  table {
    border: 1px solid #b3b3b3;
    border-collapse: collapse;
    font-size: 16px;
    line-height: 28.8px;

    @include mobile-only {
      min-width: 640px;
    }

    &__grayBack {
      font-weight: bold;
      background-color: $color-background-base;
    }

    &--grayFirstCol {
      & > tr {
        & > td:nth-child(1) {
          background-color: $color-background-base;
        }
      }
    }

    & caption {
      padding: 8px;
      color: $color-text-and-object-high-emphasis-inverse;
      background-color: $color-okaneko-blue;
      font-weight: bold;
      text-align: center;
      border: solid #b3b3b3;
      border-width: 1px 1px 0px 1px;
      caption-side: top;
    }

    & th {
      padding: 8px;
      text-align: center;
      border: 1px solid #b3b3b3;
      border-width: 1px 1px 0px 1px;
      background-color: $color-ui-background-base;
      text-align: left;
      font-weight: normal;
    }

    & thead {
      th {
        color: $color-text-and-object-high-emphasis-inverse;
        background-color: $color-okaneko-blue;
        text-align: center;
        font-weight: bold;
      }
    }

    & td {
      padding: 8px;
      font-weight: normal;
      border: 1px solid #b3b3b3;
      vertical-align: top;
    }

    & ul {
      margin-left: 2em;
      list-style-type: disc;
    }
    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }
}
</style>
